import React, {Component} from 'react';
import {Row, Col, FormGroup, Form, ButtonToolbar} from "react-bootstrap";
import {TopButtonAction, TopButtonCancel} from "../../../../../../../componentsTopsa/buttons/TopButtons";
import ObsadaService from "../../../ObsadaService";
import ObsadaListaZamianaForm from "../../../ObsadaLista/components/ObsadaListaZamianaForm";

export default class KalendarzModalEdytujZasoby extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: this.props.event,
            czyZapisano: null,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.setState({event: this.props.event})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            event: nextprops.event,
        })
    }

    onClickZapisz(obj) {
        ObsadaService.edytujZasobyObsady(obj.idOb,obj).then(function (response) {
            if (response.status < 300) {
                this.setState({czyZapisano: true})
                setTimeout(function () {
                    this.props.afterClickZapisz(response.data,'zamiana', obj);
                }.bind(this), 3000)
            }
            else {
                this.setState({czyZapisano: false})
            }
        }.bind(this))
    }


    render() {

        return (
            <div>
                {
                    (this.state.czyZapisano === null) ?
                        <div style={{width:'960px'}}>
                            <ObsadaListaZamianaForm obsadaDoZamiany={this.state.event}
                                                    handleClickAnuluj={()=>{this.props.onClickAnuluj()}}
                                                    handleEdytujZasobyObsady={this.onClickZapisz}
                            />
                        </div>
                        :
                        <div>
                            {
                                (this.state.czyZapisano) ?
                                    <h3>
                                        <i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Pomyślnie zapisano zmiany
                                        <div>
                                            <small><i className={'fa fa-circle-o-notch fa-spin'}></i> Za chwilę nastąpi odświeżenie kalendarza...
                                            </small>
                                        </div>
                                    </h3>
                                    :
                                    <h3>
                                        <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Wystąpił błąd podczas akcji
                                    </h3>
                            }
                        </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaKalendarz/components/modalComponents/KalendarzModalEdytujZasoby.js